import React, { useState, memo } from 'react';
import Modal from './Modal';
import { ModalProps, defaultProps } from './Modal.props';

const useModal = () => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  const ModalWrapper = memo(({ children, ...props }: ModalProps) => (
    <Modal
      {...props}
      open={open}
      toggleModal={closeModal}
    >
      {children}
    </Modal>
  )) as any;

  ModalWrapper.defaultProps = defaultProps;

  return { Modal: ModalWrapper, closeModal, openModal };
};

export default useModal;
